import styled from "styled-components";
import { SettingTab } from "../../views/SettingView";
import { InformationBoard } from "../board/InformationBoard";
import { NotificationForm } from "../form/NotificationForm";
import { VersionForm } from "../form/VersionForm";

interface Props {
  tabValue: SettingTab;
}

export const SettingTabPanel: React.FC<Props> = ({ tabValue }) => {
  return (
    <SettingViewViewContainer>
      {tabValue === SettingTab.Version && <VersionForm />}
      {tabValue === SettingTab.Information && <InformationBoard />}
      {tabValue === SettingTab.Notification && <NotificationForm />}
    </SettingViewViewContainer>
  );
};

const SettingViewViewContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
